import numeral from 'numeral';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './MinFundAlert.scss';

import Button from '../../Shared/Button/Button';
import { moduleActions } from '../../../redux/modules/index';

const MinFundAlert = ({
  closeModal,
  actions: { setProgress },
  fundLimit = 0,
}) => {
  return (
    <div className="min-fund-alert-container">
      <p className="min-fund-alert-modal-header">
        Increase exchange amount to meet account minimum.
      </p>
      {/*<div className="min-fund-alert-divider" />*/}
      <p className="min-fund-alert-modal-sub-header">
        To add a new investment, you will need to increase your exchange to meet
        this account's minimum ({numeral(fundLimit || 0).format('$0,0')}).
      </p>
      <div className="min-fund-alert-buttons-container">
        <Button
          id="exchange-change-amount-btn"
          buttonType="primary"
          onClick={() => {
            closeModal();
            setProgress(1);
          }}
        >
          Change Amount
        </Button>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    ...bindActionCreators(moduleActions, dispatch),
    setProgress: (step) => {
      dispatch(moduleActions.setProgress(step));
    },
  },
});

export default compose(connect(null, mapDispatchToProps))(MinFundAlert);
